import { render, staticRenderFns } from "./SkillsGoal.vue?vue&type=template&id=5c86e464&scoped=true"
import script from "./SkillsGoal.vue?vue&type=script&lang=js"
export * from "./SkillsGoal.vue?vue&type=script&lang=js"
import style0 from "./SkillsGoal.vue?vue&type=style&index=0&id=5c86e464&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86e464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c86e464')) {
      api.createRecord('5c86e464', component.options)
    } else {
      api.reload('5c86e464', component.options)
    }
    module.hot.accept("./SkillsGoal.vue?vue&type=template&id=5c86e464&scoped=true", function () {
      api.rerender('5c86e464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/rating/partials/SkillsGoal.vue"
export default component.exports